// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".svg-icon[data-v-902964d6]{width:3em;height:3em}.svg-icon path[data-v-902964d6],.svg-icon polygon[data-v-902964d6],.svg-icon rect[data-v-902964d6]{fill:#4691f6}.svg-icon circle[data-v-902964d6]{stroke:#4691f6;stroke-width:1}", ""]);
// Exports
module.exports = exports;
